const initialState = {
  loading: false
};

export const loadingProducts = (state = initialState, action) => {
  switch (action.type) {
    case 'LOADING_PRODUCTS_START':
      return {
        ...state,
        loading: true
      };

    case 'LOADING_PRODUCTS_END':
      return {
        ...state,
        loading: false
      };

    default:
      return state;
  }
};
